import { GraphQLQueryClass } from "@bsm/component";
import { THoliday, THolidaysResponse } from "@bsm/graphql";

export class HolidaysQuery
    implements GraphQLQueryClass<THolidaysResponse, TResponse>
{
    public queryKey: string = "App.Bsm.Holiday";
    public gql: string = `
    query(
        $pageSize: Float
        $page: Float
        $data: JSONObject
        $sort: [TFilterSort!]
      ) {
        holidays(
          filter: { data: $data, pageSize: $pageSize, page: $page, sort: $sort }
        ) {
            total
            data {
                id
                value
                name
                year
                holidayType
                comment
                startDate
                endDate
            }
        }
      }
      
    `;
    variables?: any;

    constructor(variables: any) {
        this.variables = variables;
    }
    mapFn(data: TResponse): THolidaysResponse {
        return {
            total: data.holidays.total,
            data: data.holidays.data,
        };
    }
}

export type TResponse = {
    holidays: {
        total: number;
        data: Array<THoliday>;
    };
};
